import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Modal } from "react-bootstrap"
import { toastr } from "react-redux-toastr"
import api from "./services/api"

import Versao from "../src/services/versao"
import Ambiente from "../src/services/ambiente"

import { logout } from "./auth/authActions"
//import api from "../src/services/api"
import minhaImagem from "./figuras/MenuHeisShop.png"

import OpcCadastro from "./modules/seguranca/usuarios/Cadastro"
import Opcstock from "./modules/relatorios/stock/stock"
import Opcprice from "./modules/relatorios/price/price"
import OpccustGrpPcg from "./modules/relatorios/custGrpPcg/custGrpPcg"
import OpcCustPrdLst from "./modules/relatorios/custPrdLst/custPrdLst"
import OpcPrdCmb from "./modules/relatorios/prdCmb/prdCmb"
import OpcCustumer from "./modules/relatorios/customer/customer"
import OpcOrder from "./modules/relatorios/order/order"

class Menu extends Component {
  constructor(props) {
    super(props)

    this.state = {
      entra: 0
      , permissoes: []
      , isModalOpen: false
      , senha: ""
      , confirmarSenha: ""
    }

    // this.buscaMenu = this.buscaMenu.bind(this);
    this.VerificaUsuarioVazio();
    this.VerificaUsuarioVazio = this.VerificaUsuarioVazio.bind(this);

    this.ChamaOpcao = this.ChamaOpcao.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.saveSenha = this.saveSenha.bind(this);
    this.setSenha = this.setSenha.bind(this);
    this.setConfirmarSenha = this.setConfirmarSenha.bind(this);
    this.limparCamposSenha = this.limparCamposSenha.bind(this);
    // this.buscamenu();
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  }

  closeModal = () => this.setState({ isModalOpen: false })

  saveSenha() {
    if (this.props.codUsuario === null || this.props.codUsuario === "" || this.props.codUsuario === undefined) {
      alert("Usuário Inválido");
    }
    else if (this.state.senha === undefined || this.state.senha === "") {
      alert("Senha vazia ou inválida");
    }
    else if (this.state.confirmarSenha === undefined || this.state.confirmarSenha === "") {
      alert("confirmarSenha vazia ou inválida");
    }
    else if (this.state.senha === this.state.confirmarSenha) {

      api.post(`/Usuario/AlteraSenha?UsuID=${this.props.codUsuario}&Senha=${this.state.senha}`)
        .then((resp) => {
          toastr.success(resp.data.message)

        })
        .catch(error => toastr.error(error));

      this.limparCamposSenha();
    }
    else {
      toastr.error("Senhas não conferem");
    }


  }

  limparCamposSenha() {
    this.setState({
      senha: ""
      , confirmarSenha: ""
    });
    this.closeModal();
  }
  setSenha(e) {
    this.setState({
      senha: e.target.value
    })
  }

  setConfirmarSenha(e) {
    this.setState({
      confirmarSenha: e.target.value
    })
  }

  VerificaUsuarioVazio() {
    //  alert("lista: " + this.props.GetListaAcesso.find(this.props.codUsuario, 1)  + " codusuario: " + this.props.codUsuario);

    //alert("lista: " + this.props.LstAcesso.indexOf(0,1));

    if (this.props.nomeUsuario === undefined) {
      this.props.logout()
    }
  }

  ChamaOpcao(Opcao) {
    this.setState({ entra: Opcao })
  }

  render() {

    const LstAcesso = this.props.GetListaAcesso || []

    return (
      <>
        <header className='dashboard-toolbar'  >
          <div className="col-md-0">
            <figure className="figure">
              <img src={minhaImagem} alt="" ></img>
            </figure>
          </div>

          <div className="col-md-2" style={{ marginLeft: "5%", fontSize: "17px", fontFamily: "Barlow" }}>
            Olá, &nbsp; {this.props.nomeUsuario} !
          </div >


          <div className="col-md-2" style={{ fontSize: "17px", fontFamily: "Barlow" }}>
            <div type="button"
              data-toggle="tooltip" data-placement="right"
              title="Alterar Senha">
              <i className="fa fa-key" aria-hidden="true"
                onClick={this.openModal}
              >
              </i>
            </div>
          </div >
          
          <div className="col-md-2" style={{ fontSize: "15px", fontFamily: "Barlow" }}>
            <span style={{ fontSize: "9px" }}>{Ambiente}</span>
          </div>

          

          <div className="col-md-2" style={{ fontSize: "15px", fontFamily: "Barlow" }}>
            <span style={{ fontSize: "9px" }}>{Versao}</span>
          </div>

         

          <div className="col-md-2" style={{ fontSize: "15px", fontFamily: "Barlow" }}>
            <span
              style={(this.props.VersaoBackEnd === undefined ? { fontSize: "9px", color: 'red' } : { fontSize: "9px" })}
            >Versão Back End: {this.props.VersaoBackEnd}
              &nbsp;&nbsp;
              {(this.props.VersaoBackEnd === undefined
                ? "Desconection" : "Conection")}
            </span>
          </div>
          {/* </div> */}
          {/* {this.props.EnderecoHTTPS_A} */}
        </header>

        {/* Comando para ocultar o menu na imprenssao d-print-none */}
        <div className="dashboard-nav d-print-none" >
          <nav className="dashboard-nav-list" >
            <div className="btn bg-menuLateraltitulo" data-bs-toggle="collapse"
              data-bs-target="#dashboard-collapse" aria-expanded="false"
              onClick={() => { this.ChamaOpcao(0) }}>
              <div>
                <figure className="figure">
                  {/* <img src={service_icon}></img> */}
                </figure>
              </div>
              &nbsp;&nbsp; Inicial
            </div>

            <br />

            {/* <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse1" aria-haspopup="true" aria-expanded="false"
                disabled={LstAcesso.find(i => i.mnuid === 2) === undefined ? "disabled" : ""}
              >
                &nbsp;&nbsp; Products
              </button>
            </div> */}
            <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse1" aria-haspopup="true" aria-expanded="false"
                disabled={LstAcesso.find(i => i.mnuid === 10) === undefined ? "disabled" : ""}
                onClick={() => { this.ChamaOpcao(5) }}
              >
                &nbsp;&nbsp; Products Combo
              </button>
            </div>
            <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse2" aria-haspopup="true" aria-expanded="false"
                disabled={LstAcesso.find(i => i.mnuid === 3) === undefined ? "disabled" : ""}
                onClick={() => { this.ChamaOpcao(2) }}
              >
                &nbsp;&nbsp; Stock
              </button>
            </div>
            <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse3" aria-haspopup="true" aria-expanded="false"
                disabled={LstAcesso.find(i => i.mnuid === 4) === undefined ? "disabled" : ""}
                onClick={() => { this.ChamaOpcao(3) }}
              >
                &nbsp;&nbsp; Price
              </button>
            </div>
            <div>
              <button className="btn bg-menuLateraltitulo" data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse0" aria-haspopup="true" aria-expanded="false"
                disabled={LstAcesso.find(i => i.mnuid === 1) === undefined ? "disabled" : ""}
                onClick={() => { this.ChamaOpcao(6) }}
              >
                &nbsp;&nbsp; Customers
              </button>
            </div>
            <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse6" aria-haspopup="true" aria-expanded="false"
                disabled={LstAcesso.find(i => i.mnuid === 7) === undefined ? "disabled" : ""}
                onClick={() => { this.ChamaOpcao(7) }}
              >
                &nbsp;&nbsp; Customer Group
              </button>
            </div>
            <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse4" aria-haspopup="true" aria-expanded="false"
                disabled={LstAcesso.find(i => i.mnuid === 5) === undefined ? "disabled" : ""}
                onClick={() => { this.ChamaOpcao(4) }}
              >
                &nbsp;&nbsp; Customer Product List
              </button>
            </div>

            <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse5" aria-haspopup="true" aria-expanded="false"
                disabled={LstAcesso.find(i => i.mnuid === 6) === undefined ? "disabled" : ""}
              >
                &nbsp;&nbsp; Promotion
              </button>
            </div>
            <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse7" aria-haspopup="true" aria-expanded="false"
                disabled={LstAcesso.find(i => i.mnuid === 8) === undefined ? "disabled" : ""}
                onClick={() => { this.ChamaOpcao(8) }}
              >
                &nbsp;&nbsp; Order
              </button>
            </div>
            {/* 
          <div>
            <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
              data-bs-target="#dashboard-collapse8" aria-haspopup="true" aria-expanded="false"
              disabled={LstAcesso.find(i => i.mnuid === 9) === undefined ? "disabled" : ""}
            >
              &nbsp;&nbsp; Order Status
            </button>
          </div> 
          */}
            <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                // <button className="btn bg-menuLateraltitulo dropdown-toggle" data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse9" aria-haspopup="true" aria-expanded="false"
                onClick={() => { this.ChamaOpcao(1) }}
                //disabled= {(LstAcesso.indexOf(this.props.codUsuario, 20) === -1 ? "disabled" : "")}
                // disabled= {(LstAcesso.indexOf(this.props.codUsuario, 20) === -1 ? "" : "")}
                //disabled= {LstAcesso.find( ({ mnuid }) => mnuid === 20 ? "" : "disabled")}
                disabled={LstAcesso.find(i => i.mnuid === 20) === undefined ? "disabled" : ""}
              >
                &nbsp;&nbsp;
                Usuários
              </button>

            </div>

            <br />
            <div>
              <button className="btn bg-menuLateraltitulo " data-bs-toggle="collapse"
                // <button className="btn bg-menuLateraltitulo dropdown-toggle" data-bs-toggle="collapse"
                data-bs-target="#dashboard-collapse9" aria-haspopup="true" aria-expanded="false"
                onClick={this.props.logout}>
                <i className="fa fa-sign-out" aria-hidden="true"></i>
                Sair
              </button>
              {/* href="#" className="dashboard-nav-item" onClick={this.props.logout}
              style={{ color: "#36561e" }}>
              <i className="fa fa-sign-out" aria-hidden="true"></i>
              Sair */}
            </div>
            <br />
          </nav>
        </div>
        <div className='dashboard-app d-print-none' >

          {/* <div className='dashboard-app d-print-none' >
           <div className='dashboard-content' >
            <div className='container' >
              <div className='card' >
                <div className='card-body'
                  style={{ display: (this.state.entra === 0 ? "flex" : "none"), backgroundColor: "#f8f8f8" }}
                >
                </div>
              </div>
            </div>
          </div>  */}

          <div className='dashboard-content' style={{ display: (this.state.entra === 1 ? "flex" : "none") }}>
            <div className='container' >
              <div className='card' >
                <div className='card-body'
                >
                  {(this.state.entra === 1 ? <OpcCadastro /> : false)}
                </div>
              </div>
            </div>
          </div>

          <div className='dashboard-content' style={{ display: (this.state.entra === 6 ? "flex" : "none") }} >
            <div className='container' >
              <div className='card' >
                <div className='card-body'>
                  {(this.state.entra === 6 ? <OpcCustumer /> : false)}
                </div>
              </div>
            </div>
          </div>

          <div className='dashboard-content' style={{ display: (this.state.entra === 8 ? "flex" : "none") }} >
            <div className='container' >
              <div className='card' >
                <div className='card-body'>
                  {(this.state.entra === 8 ? <OpcOrder /> : false)}
                </div>
              </div>
            </div>
          </div>
          <div className='dashboard-content' style={{ display: (this.state.entra === 5 ? "flex" : "none") }} >
            <div className='container' >
              <div className='card' >
                <div className='card-body'>
                  {(this.state.entra === 5 ? <OpcPrdCmb /> : false)}
                </div>
              </div>
            </div>
          </div>

          <div className='dashboard-content' style={{ display: (this.state.entra === 4 ? "flex" : "none") }} >
            <div className='container' >
              <div className='card' >
                <div className='card-body'>
                  {(this.state.entra === 4 ? <OpcCustPrdLst /> : false)}
                </div>
              </div>
            </div>
          </div>

          <div className='dashboard-content' style={{ display: (this.state.entra === 2 ? "flex" : "none") }} >
            <div className='container' >
              <div className='card' >
                <div className='card-body'>
                  {(this.state.entra === 2 ? <Opcstock /> : false)}
                </div>
              </div>
            </div>
          </div>

          <div className='dashboard-content' style={{ display: (this.state.entra === 3 ? "flex" : "none") }} >
            <div className='container' >
              <div className='card' >
                <div className='card-body'>
                  {(this.state.entra === 3 ? <Opcprice /> : false)}
                </div>
              </div>
            </div>
          </div>

          <div className='dashboard-content' style={{ display: (this.state.entra === 7 ? "flex" : "none") }} >
            <div className='container' >
              <div className='card' >
                <div className='card-body'>
                  {(this.state.entra === 7 ? <OpccustGrpPcg /> : false)}
                </div>
              </div>
            </div>
          </div>

        </div>

        {/*
        <div className='dashboard-content' style={{ display: (this.state.entra === 6 ? "flex" : "none") }} >
          <div className='container' >
            <div className='card' >
              <div className='card-body'>
                {(this.state.entra === 6 ? <OpcCustomer /> : false)}
              </div>
            </div>
          </div>
        </div>

        <div className='dashboard-content' style={{ display: (this.state.entra === 8 ? "flex" : "none") }} >
          <div className='container' >
            <div className='card' >
              <div className='card-body'>
                {(this.state.entra === 8 ? <OpcCustDlry /> : false)}
              </div>
            </div>
          </div>
        </div>

        <div className='dashboard-content' style={{ display: (this.state.entra === 9 ? "flex" : "none") }} >
          <div className='container' >
            <div className='card' >
              <div className='card-body'>
                {(this.state.entra === 9 ? <OpcCustFin /> : false)}
              </div>
            </div>
          </div>
        </div> 
        */}

        <Modal size="lg" show={this.state.isModalOpen}
          onHide={this.closeModal}
        >
          <Modal.Header>
            <Modal.Title
              style={{
                color: "#77b935"
                , fontFamily: "Barlow"
                , fontSize: "22px"
                , fontStyle: "Italic"
              }} > Manutenção da senha do Usuário: &nbsp; &nbsp;
              {(this.props.nomeUsuario)}
            </Modal.Title>

          </Modal.Header>
          <Modal.Body style={{ color: "#77b935" }}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group LancPeriodos">
                  <div style={{ paddingLeft: "20px" }}>
                    <label >Senha</label>
                    <input type="password" className="form-control"
                      onChange={this.setSenha}
                      maxLength="20"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group LancPeriodos">
                  <label>Confirmar Senha</label>
                  <input type="password" className="form-control"
                    onChange={this.setConfirmarSenha}
                    maxLength="20"
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row" >
              <div className="col-md-2"></div>
              <div className="col-md-6">
                <button type="button"
                  style={{ background: "#77b935" }}
                  className="btn btn-secondary"
                  onClick={this.saveSenha}
                >Salvar
                </button>
              </div>

              <div className="col-md-2">
                <button type="button"
                  style={{ background: "#77b935" }}
                  className="btn btn-secondary"
                  onClick={this.closeModal}
                >Fechar
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>


      </>
    )
  }
}

//export default Menu

const mapStateToProps = state => ({
  codUsuario: state.authRed.CodUsuario
  , nomeUsuario: state.authRed.NomUsuario
  , GetListaAcesso: state.authRed.LstdeAcessoUsu
  , VersaoBackEnd: state.authRed.VersaoBackEndcc
  // , EnderecoHTTPS_A = state.auth.EnderecoHTTPS
})
const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Menu) 